import * as React from 'react';

import {ChipsFormatter} from './ChipsFormatter';
import {DRP_LINE_HEIGHT} from './PhRecommendationDrpBaseFormatter';

export type PhRecommendationDrpItemFormatterProps = {
  value: string;
  tooltipOverride?: JSX.Element;
  background?: string;
};
export const PhRecommendationDrpItemFormatter: React.FC<PhRecommendationDrpItemFormatterProps> = ({value, tooltipOverride, background}) => {
  return (
    <ChipsFormatter
      style={{margin: 0, lineHeight: 1}}
      chipStyle={{height: `${DRP_LINE_HEIGHT}px`}}
      value={[value]}
      getInfo={(singleValue) => ({
        label: singleValue,
        background,
      })}
      tooltip={tooltipOverride ?? value}
    />
  );
};
